import { InjectionToken } from "@angular/core";

export interface HostMapping {
  [key: string]: string
}

// !Not in use
export const HOST_MAPPING = new InjectionToken<HostMapping>('HOST_MAPPING');
